<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div>
    <!-- TABELA DE APIS -->

    <button type="button" class="btn btn-primary" @click="buscarSaldoSMSDev()">Verificar saldo SMS dev</button>

    <span style="font-weight: bold; margin-left: 15px" v-if="saldo_sms_dev">Saldo atual: {{ saldo_sms_dev }} Sms restante(s)</span>

    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Apis</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>

      <div class="card-body table-responsive p-0">
        <table class="table table-hover text-nowrap" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Nome</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(api, index) in apis" :key="api">
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Nome">{{ api.nome }}</td>
              <td data-label="Status">
                <span :class="findStatus(api) == 'online' ? 'online' : 'offline'">{{ findStatus(api) }}</span>
              </td>
              <td data-label="Ações">
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div id="meu_menu" class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>

                  <a href="#" @click="pararApi(api)" class="dropdown-item">
                    <i class="fa-solid fa-stop"></i>
                    &nbsp;&nbsp; Parar
                  </a>

                  <div class="dropdown-divider"></div>
                  <a href="#" @click="reiniciarApi(api)" class="dropdown-item">
                    <i class="fa-solid fa-arrow-rotate-right"></i>
                    &nbsp;&nbsp; Reiniciar
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + lotes.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import sweetAlert from "../../controller/sweetAlert";
import currencyController from "../../controller/currencyController";

import ContextMenu from "primevue/contextmenu";

export default {
  props: ["apis"],

  mixins: [sweetAlert, currencyController],

  components: { Loading, ContextMenu },

  data() {
    return {
      isLoading: false,
      leilao_selecionado: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      lotes: [],
      cidades: [],
      numero: "",
      estado: "",
      cidade: "",
      titulo: "",
      descricao: "",
      lotes: [],
      lote_selecionado: "",
      processos: [],
      saldo_sms_dev: null,
    };
  },

  mounted() {
    console.log(this.leilao);
    this.buscarStatusApi();

    console.log("apiS");

    console.log(document.getElementById("newMenu"));
  },

  methods: {
    buscarSaldoSMSDev() {
      this.isLoading = true;

      axios
        .get("/admin/smsdev/saldo")
        .then((response) => {
          this.isLoading = false;
          this.saldo_sms_dev = response.data.saldo_sms;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    pararApi(api) {
      this.isLoading = true;

      let data = {
        appName: api.nome_pm2,
      };

      console.log(data);

      axios
        .post(`/admin/api/pm2/stop`, data)
        .then((response) => {
          this.buscarStatusApi();
          this.registrarAcao("Stop", api.id);
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    reiniciarApi(api) {
      this.isLoading = true;

      let data = {
        appName: api.nome_pm2,
      };

      console.log(data);

      axios
        .post(`/admin/api/pm2/restart`, data)
        .then((response) => {
          console.log("apis");
          console.log(response.data);
          let that = this;
          this.registrarAcao("Restart", api.id);

          setTimeout(() => {
            that.buscarStatusApi();
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    buscarStatusApi() {
      this.isLoading = true;

      let data = {};

      console.log(data);

      axios
        .get(`/admin/api/pm2/get_status`)
        .then((response) => {
          this.isLoading = false;
          console.log("apis");
          console.log(response.data);

          this.processos = response.data.processos;
          console.log(this.apis);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    registrarAcao(acao, api_id) {
      this.isLoading = true;

      let data = {
        api_id: api_id,
        acao: acao,
      };

      console.log(data);

      axios
        .post("/admin/apis/registrar_acao", data)
        .then((response) => {})
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    findStatus(api) {
      if (this.processos) {
        let indice = this.processos.findIndex((element) => element["nome"] == api.nome_pm2);

        if (indice >= 0) {
          return this.processos[indice].status;
        }
      } else {
        return "";
      }
    },

    changeStatus(lote) {
      console.log(lote);

      let data = {
        lote_id: lote.id,
        lote_oculto: this.convertToTiny(lote.lote_oculto),
      };

      console.log(data);

      axios
        .post(`/admin/lote/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLotes();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLotes();
      }
    },

    buscarLotes() {
      this.isLoading = true;

      let data = {
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log(data);

      axios
        .post(`/admin/apis/search`, data)
        .then((response) => {
          this.apis = response.data.apis;
          this.total = response.data.total;

          this.jobs = response.data.jobs;

          console.log("apis");
          console.log(this.apis);
          console.log(response.data);

          this.pagination(response.data);
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarLotes();
    },

    deletar(lote) {
      this.leilao_selecionado = lote;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o tipo de lote<b><br/>" + this.leilao_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.leilao_selecionado.id,
            };

            axios
              .post(`/admin/lote/delete`, data)
              .then((response) => {
                this.showSuccessMessage("lote deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.online {
  font-weight: bold;
  color: #1d743a;
}

.offline {
  color: red;
}

.progress-btn {
  position: relative;
  width: 150px;
  height: 40px;
  display: inline-block;
  font-family: "RobotoDraft", "Roboto", sans-serif;
  color: #fff !important;
  font-weight: normal;
  font-size: 20px;
  transition: all 0.4s ease;
  border: 2px solid white;
}
.progress-btn:not(.active) {
  cursor: pointer;
}

.progress-btn .btn {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  line-height: 5px;
  text-align: center;
  z-index: 10;
  opacity: 1;
}

.progress-btn .progress {
  width: 0%;
  z-index: 5;
  background: #1d743a;
  opacity: 0;
  transition: all 0.3s ease;
  height: 5px;
}

.progress-btn .progress {
  opacity: 1;
  animation: progress-anim 2s ease infinite;
}

.progress-btn[data-progress-style="fill-back"] .progress {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

@keyframes progress-anim {
  0% {
    width: 0%;
  }
  5% {
    width: 0%;
  }
  10% {
    width: 15%;
  }
  30% {
    width: 40%;
  }
  50% {
    width: 55%;
  }
  80% {
    width: 100%;
  }
  95% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}

.span-green {
  background-color: green;
}

.span-grwy {
  background-color: gray;
}

.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
